// Convertiert C# Boolean in JavaScript Boolean. Automagisch!! :-)
var True = true;
var False = false;